export const TILE_IMAGES = [
  { src: "/collage/000.jpg", shoot: "6R7A0011" },
  { src: "/collage/001.jpg", shoot: "6R7A0074" },
  { src: "/collage/002.jpg", shoot: "6R7A0074" },
  { src: "/collage/003.jpg", shoot: "6R7A0075" },
  { src: "/collage/004.jpg", shoot: "6R7A0075" },
  { src: "/collage/005.jpg", shoot: "6R7A0107" },
  { src: "/collage/006.jpg", shoot: "6R7A0163" },
  { src: "/collage/007.jpg", shoot: "6R7A0174_with" },
  { src: "/collage/008.jpg", shoot: "6R7A0195" },
  { src: "/collage/009.jpg", shoot: "6R7A0201" },
  { src: "/collage/010.jpg", shoot: "6R7A0213" },
  { src: "/collage/011.jpg", shoot: "6R7A0228" },
  { src: "/collage/012.jpg", shoot: "6R7A0274" },
  { src: "/collage/013.jpg", shoot: "6R7A0315" },
  { src: "/collage/014.jpg", shoot: "6R7A0315" },
  { src: "/collage/015.jpg", shoot: "6R7A0315" },
  { src: "/collage/016.jpg", shoot: "6R7A0372" },
  { src: "/collage/017.jpg", shoot: "6R7A0372" },
  { src: "/collage/018.jpg", shoot: "6R7A0372" },
  { src: "/collage/019.jpg", shoot: "6R7A0372" },
  { src: "/collage/020.jpg", shoot: "6R7A0379" },
  { src: "/collage/021.jpg", shoot: "6R7A0379" },
  { src: "/collage/022.jpg", shoot: "6R7A0379" },
  { src: "/collage/023.jpg", shoot: "6R7A0379" },
  { src: "/collage/024.jpg", shoot: "6R7A0433" },
  { src: "/collage/025.jpg", shoot: "6R7A0521" },
  { src: "/collage/027.jpg", shoot: "6R7A0577" },
  { src: "/collage/028.jpg", shoot: "6R7A0597" },
  { src: "/collage/029.jpg", shoot: "6R7A0597" },
  { src: "/collage/030.jpg", shoot: "6R7A0597" },
  { src: "/collage/031.jpg", shoot: "6R7A0726" },
  { src: "/collage/032.jpg", shoot: "6R7A0726" },
  { src: "/collage/033.jpg", shoot: "6R7A0727" },
  { src: "/collage/034.jpg", shoot: "6R7A0739" },
  { src: "/collage/035.jpg", shoot: "6R7A0749" },
  { src: "/collage/036.jpg", shoot: "6R7A0752" },
  { src: "/collage/037.jpg", shoot: "6R7A0752" },
  { src: "/collage/038.jpg", shoot: "6R7A0752" },
  { src: "/collage/039.jpg", shoot: "6R7A0769" },
  { src: "/collage/040.jpg", shoot: "6R7A0769" },
  { src: "/collage/041.jpg", shoot: "6R7A0771" },
  { src: "/collage/042.jpg", shoot: "6R7A0771" },
  { src: "/collage/043.jpg", shoot: "6R7A0771" },
  { src: "/collage/044.jpg", shoot: "6R7A0789" },
  { src: "/collage/045.jpg", shoot: "6R7A0789" },
  { src: "/collage/046.jpg", shoot: "6R7A0835" },
  { src: "/collage/047.jpg", shoot: "6R7A0844" },
  { src: "/collage/048.jpg", shoot: "6R7A0844" },
  { src: "/collage/049.jpg", shoot: "6R7A0904" },
  { src: "/collage/050.jpg", shoot: "6R7A0969" },
  { src: "/collage/051.jpg", shoot: "6R7A0973" },
  { src: "/collage/052.jpg", shoot: "6R7A0983" },
  { src: "/collage/053.jpg", shoot: "6R7A0996" },
  { src: "/collage/054.jpg", shoot: "6R7A1007" },
  { src: "/collage/055.jpg", shoot: "6R7A1078" },
  { src: "/collage/056.jpg", shoot: "6R7A1090" },
  { src: "/collage/057.jpg", shoot: "6R7A1111" },
  { src: "/collage/058.jpg", shoot: "6R7A1175" },
  { src: "/collage/059.jpg", shoot: "6R7A1386" },
  { src: "/collage/060.jpg", shoot: "6R7A1461" },
  { src: "/collage/061.jpg", shoot: "6R7A1468" },
  { src: "/collage/062.jpg", shoot: "6R7A9475" },
  { src: "/collage/063.jpg", shoot: "6R7A9589" },
  { src: "/collage/064.jpg", shoot: "6R7A9602" },
  { src: "/collage/065.jpg", shoot: "6R7A9604" },
  { src: "/collage/070.jpg", shoot: "6R7A9731" },
  { src: "/collage/071.jpg", shoot: "6R7A9731" },
  { src: "/collage/072.jpg", shoot: "6R7A9731" },
  { src: "/collage/073.jpg", shoot: "6R7A9781" },
  { src: "/collage/074.jpg", shoot: "6R7A9781" },
  { src: "/collage/075.jpg", shoot: "6R7A9781" },
  { src: "/collage/076.jpg", shoot: "6R7A9781" },
  { src: "/collage/077.jpg", shoot: "Adjusted" },
  { src: "/collage/078.jpg", shoot: "Amrita" },
  { src: "/collage/079.jpg", shoot: "AS" },
  { src: "/collage/080.jpg", shoot: "AS" },
  { src: "/collage/081.jpg", shoot: "AS" },
  { src: "/collage/082.jpg", shoot: "AS" },
  { src: "/collage/083.jpg", shoot: "AS" },
  { src: "/collage/084.jpg", shoot: "Aura" },
  { src: "/collage/085.jpg", shoot: "Big" },
  { src: "/collage/086.jpg", shoot: "Black" },
  { src: "/collage/087.jpg", shoot: "Black" },
  { src: "/collage/088.jpg", shoot: "Black" },
  { src: "/collage/089.jpg", shoot: "Blue" },
  { src: "/collage/090.jpg", shoot: "Blue" },
  { src: "/collage/091.jpg", shoot: "Blue" },
  { src: "/collage/092.jpg", shoot: "Blue" },
  { src: "/collage/093.jpg", shoot: "Blue" },
  { src: "/collage/094.jpg", shoot: "Blue" },
  { src: "/collage/095.jpg", shoot: "Blue" },
  { src: "/collage/096.jpg", shoot: "Face" },
  { src: "/collage/098.jpg", shoot: "GenAIImage_0fe37338" },
  { src: "/collage/099.jpg", shoot: "GenAIImage_4399636d" },
  { src: "/collage/100.jpg", shoot: "GenAIImage_6b0fb8cd" },
  { src: "/collage/101.jpg", shoot: "GenAIImage_739da810" },
  { src: "/collage/102.jpg", shoot: "GenAIImage_96eac364" },
  { src: "/collage/103.jpg", shoot: "GenAIImage_a82a0228" },
  { src: "/collage/104.jpg", shoot: "GenAIImage_cd83d746" },
  { src: "/collage/105.jpg", shoot: "GenAIImage_d6f364fb" },
  { src: "/collage/106.jpg", shoot: "GenAIImage_dae11742" },
  { src: "/collage/107.jpg", shoot: "GenAIImage_e27c7cd4" },
  { src: "/collage/108.jpg", shoot: "GenAIImage_e62b9ec8" },
  { src: "/collage/109.jpg", shoot: "getting" },
  { src: "/collage/110.jpg", shoot: "Holding" },
  { src: "/collage/111.jpg", shoot: "IMG_4128" },
  { src: "/collage/112.jpg", shoot: "IMG_4129" },
  { src: "/collage/113.jpg", shoot: "IMG_4148" },
  { src: "/collage/114.jpg", shoot: "IMG_4148g" },
  { src: "/collage/115.jpg", shoot: "IMG_4150" },
  { src: "/collage/116.jpg", shoot: "Rainbow" },
  { src: "/collage/117.jpg", shoot: "Red" },
  { src: "/collage/118.jpg", shoot: "Red" },
  { src: "/collage/119.jpg", shoot: "Red" },
  { src: "/collage/120.jpg", shoot: "Red" },
  { src: "/collage/121.jpg", shoot: "Red" },
  { src: "/collage/122.jpg", shoot: "Red" },
  { src: "/collage/123.jpg", shoot: "Vintage" },
  { src: "/collage/124.jpg", shoot: "WhatsApp" },
  { src: "/collage/125.jpg", shoot: "Wonderwoman" },
  { src: "/collage/126.jpg", shoot: "Wonderwoman" },
  { src: "/collage/127.jpg", shoot: "Wonderwoman" },
];
